import TextField, { TextFieldProps, TextFieldVariants } from "@mui/material/TextField";
import { ChangeEventHandler, SyntheticEvent, useEffect, useState } from "react";

interface MuiInputProps extends Omit<TextFieldProps<'outlined'>, 'error'>{
    width?: string | number,
    onInputChange?: (e: SyntheticEvent, input?: string) => void
    onChange?: (e: SyntheticEvent, input?: string) => void
    error?: string
}

export const MuiInput = (props: Partial<MuiInputProps>) => {
    const {
        name,
        error = null,
        variant = "outlined",
        type = "text",
        value,
        width,
        size = 'small',
        onChange,
        onInputChange,
        required,
        ...others
    } = props;

    const maxLength = props?.inputProps?.maxLength || 100;

    const [inputValue, setInputValue] = useState<any>('');

    useEffect(() => {
        setInputValue(value);
    }, [value])


    const onBlur = (e: any) => {
        if (onChange) {
            onChange(e, inputValue);
        }
    }

    const handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
        let input: string = e.target.value;

        if (input !== '' && type === 'number') {
            input = isNaN(Number(input)) ? inputValue : input;
        }
        
        if (input.length <= maxLength) setInputValue(input);
        if (onInputChange) onInputChange(e, input);
    }

    return (
        <TextField
            name={name}
            type={type}
            id="outlined-multiline-static"
            size={size}
            sx={{ width: { width } }}
            variant={variant}
            value={inputValue}
            required={required}
            {...others}
            onBlur={onBlur}
            onChange={handleChange}
            {...(error && { error: true, helperText: error })}
        />
    );
}
